import React from 'react';

import { IconProps } from '../../DefaultIcon';

export function MedicaLeavesIcon({ className }: IconProps) {
  return (
    <svg
      width="83"
      height="72"
      viewBox="0 0 83 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_678)">
        <path
          d="M73.5566 71.9999H9.44341C5.2832 71.9999 1.88867 68.6593 1.88867 64.5089V19.6386C1.88867 15.5134 5.25768 12.1729 9.44341 12.1729H73.5821C77.7423 12.1729 81.1368 15.5134 81.1368 19.6386V64.5342C81.1368 68.6593 77.7678 72.0252 73.5821 72.0252"
          fill="#EAEDF8"
        />
        <path
          d="M65.2361 14.1975H59.1107V8.45264C59.1107 7.21257 58.0898 6.20027 56.8391 6.17496L26.365 6.04842C25.0633 6.04842 23.9914 7.08603 23.9658 8.37672L23.8637 14.1721H17.7383V6.17496C17.7383 2.75844 20.5458 -0.0253906 23.9914 -0.0253906H58.9575C62.4031 -0.0253906 65.2106 2.75844 65.2106 6.17496V14.1721L65.2361 14.1975Z"
          fill="#00416B"
        />
        <path
          d="M77.5381 32.2164H5.46187C2.45018 32.2164 0 29.7869 0 26.8259V17.5634C0 14.5771 2.45018 12.1729 5.46187 12.1729H77.5637C80.5753 12.1729 83 14.6024 83 17.5634V26.8259C83 29.8122 80.5498 32.2164 77.5637 32.2164"
          fill="#00416B"
        />
        <path
          d="M41.5004 65.9767C39.6883 65.9767 38.208 64.5089 38.208 62.712V42.0611C38.208 40.2642 39.6883 38.7964 41.5004 38.7964C43.3126 38.7964 44.7929 40.2642 44.7929 42.0611V62.712C44.7929 64.5089 43.3126 65.9767 41.5004 65.9767Z"
          fill="#00C4B3"
        />
        <path
          d="M55.2054 52.3867C55.2054 54.1836 53.7251 55.6514 51.9129 55.6514H31.0864C29.2743 55.6514 27.7939 54.1836 27.7939 52.3867C27.7939 50.5899 29.2743 49.1221 31.0864 49.1221H51.9129C53.7251 49.1221 55.2054 50.5899 55.2054 52.3867Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_678">
          <rect width="83" height="72" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
